import * as storage from '@actions/storage';
import { v4 as uuidv4 } from 'uuid';

const META_EVENT_ID_KEY = 'metaEventId';

export const getMetaEventId = (): string | null =>
  storage.get<string>(META_EVENT_ID_KEY);

// Dedup key for one user: across intro→multipage, and Meta Pixel ↔ Conversions API.
export const ensureMetaEventId = (): string => {
  const existing = getMetaEventId();
  if (existing) return existing;

  const id = uuidv4();
  storage.set(META_EVENT_ID_KEY, id);
  return id;
};
